import { render, staticRenderFns } from "./branchverifycheck.vue?vue&type=template&id=54475b9d&scoped=true&"
import script from "./branchverifycheck.vue?vue&type=script&lang=js&"
export * from "./branchverifycheck.vue?vue&type=script&lang=js&"
import style0 from "./branchverifycheck.vue?vue&type=style&index=0&id=54475b9d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54475b9d",
  null
  
)

export default component.exports